module.exports = __webpack_public_path__ + "img/bin.8c35a09e.svg";